// extracted by mini-css-extract-plugin
module.exports = {"container":"EditOrderModal_container__uVEqF"};